<template>
  <div id="index">
    <router-link class="chat" to="/ContactUs">
      <div class="chat_box">
        <img src="../src/assets/chat.png" />
      </div>
      <p>Online contact</p>
    </router-link>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      setting: {
        title: "",
        keywords: "",
        description: "",
      },
    };
  },
  metaInfo() {
    return {
      title: this.setting.title,
      meta: [
        { name: "keywords", content: this.setting.keywords },
        { name: "description", content: this.setting.description },
      ],
    };
  },
  mounted() {
    this.Init();
  },
  methods: {
    Init() {
    },
  },
  created() {
    $.ajax({
      url: "/index.php?s=Home/Api/get_data",
      type: "post",
      datatype: "json",
      async: false,
      data: {
        act: "save_biaoshi",
        chushihua: 1,
      },
      success: function (ret) {},
      error: function (err) {
      },
    });
  },
};


var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/5df9da0343be710e1d229651/default';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();
</script>

<!--Start of Tawk.to Script-->

<!--End of Tawk.to Script-->

<style lang='scss'>
#index {
  background: #fafafa;
}
#index .el-backtop {
  width: 50px;
  height: 60px;
  border-radius: 0;
}

.bottom_box {
  font-size: 0.8rem;
}

.bottom_box::before {
  content: "";
  width: 0px;
  height: 0px;
  border-left: 15px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: 60px solid #1989fa;
  position: absolute;
  top: 0px;
  left: -15px;
}

#index .el-backtop div {
}



.chat {
  width: 145px;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 2px 9px 1px rgba(138, 138, 138, 0.2);
  position: fixed;
  right: 0;
  bottom: 25%;
  z-index: 999;
  .chat_box {
    width: 56px;
    height: 42px;
    margin: 20px auto 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  p {
    display: block;
    text-align: center;
    margin: 10px auto 0;
    font-size: 0.8rem;
    font-weight: bold;
    color: #5fbb68;
  }
}
</style>



// WEBPACK FOOTER //
// src/Index.vue